var map = {
	"./studio_auto-not-selected.svg": 163,
	"./studio_auto-selected.svg": 415,
	"./studio_europe-not-selected.svg": 164,
	"./studio_europe-selected.svg": 416,
	"./studio_international-not-selected.svg": 165,
	"./studio_international-selected.svg": 417,
	"./studio_manual-not-selected.svg": 121,
	"./studio_manual-selected.svg": 166,
	"./studio_proofreading-not-selected.svg": 167,
	"./studio_proofreading-selected.svg": 418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;